import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import Utility from './Utility';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';

class Szolgaltatas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: false,
      dataFailed: false,
      insert: true,
      raktarLoading: false,
      modalSzolgaltatas: false,
      modalSzolgaltatasTorles: false,
      raktar: {},
      szolgaltatasok: [],
      szolgaltatasModositObj: {},
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD'
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '1' && this.props.activeTab === '1') {
      this.updateTable();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['IDOPONT_SZOLGALTATAS'], true);
  }

  handleRaktarChange = (raktar) => {
    if (raktar) {
      this.setState({ raktar: raktar });
    } else {
      this.setState({ raktar: null });
    }
  }

  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' }, () => {
      Service.listSzolgaltatas(null, null, (err, res) => {
        if (!err) {
          let status = res[0].length == 0 ? 'DATA' : 'TABL';
          this.setState({ szolgaltatasok: res[0], tableStatus: status });
        } else {
          this.setState({ tableStatus: 'NETW' });
        }
      });
    });
  }

  toggleSzolgaltatas = () => {
    this.setState((prevState) => { return ({ modalSzolgaltatas: !prevState.modalSzolgaltatas }); });
  }

  toggleSzolgaltatasView = () => {
    this.setState((prevState) => { return ({ modalSzolgaltatasView: !prevState.modalSzolgaltatasView }) });
  }

  toggleSzolgaltatasTorles = () => {
    this.setState((prevState) => { return ({ modalSzolgaltatasTorles: !prevState.modalSzolgaltatasTorles }); });
  }

  handleSzolgaltatasAddClick = () => {
    this.setState({ insert: true });
    this.toggleSzolgaltatas();
  }

  handleSzolgaltatasViewClick = (id) => {
    this.setState((prevState) => {
      const szolgaltatas = prevState.szolgaltatasok.find(element => element.id === id);
      return ({ szolgaltatasModositObj: szolgaltatas });
    });
    this.toggleSzolgaltatasView();
  }

  handleSzolgaltatasEditClick = (id) => {
    this.setState((prevState) => {
      const szolgaltatas = prevState.szolgaltatasok.find(element => element.id === id);
      return ({ szolgaltatasModositObj: szolgaltatas, insert: false });
    });
    this.toggleSzolgaltatas();
  }

  handleSzolgaltatasDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleSzolgaltatasTorles();
  }

  iconFormatter = (cell) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleSzolgaltatasViewClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {
          this.hasRoleKarb()
            ? (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleSzolgaltatasEditClick(cell)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleSzolgaltatasDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
              </React.Fragment>
            )
            : <div />
        }


      </div>
    );
  }

  addSzolgaltatas = (event, szolgaltatasObj) => {
    Service.addSzolgaltatas(szolgaltatasObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleSzolgaltatas();
        this.props.globals.addSuccess('Szolgáltatás hozzáadva!');
      }
    });
  }

  modifySzolgaltatas = (event, szolgaltatasObj) => {
    szolgaltatasObj.id = this.state.szolgaltatasModositObj.id;
    Service.editSzolgaltatas(szolgaltatasObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleSzolgaltatas();
        this.props.globals.addSuccess('Szolgáltatás módosítva!');
      }
    });
  }

  deleteSzolgaltatas = () => {
    this.toggleSzolgaltatasTorles();
    Service.deleteSzolgaltatas(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Szolgáltatás törölve!');
      }
    });
  }

  statusFormatter = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Aktív</span>;
      case false:
        return <span className="badge badge-default">Inaktív</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  statusFormatterPublic = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Igen</span>;
      case false:
        return <span className="badge badge-default">Nem</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  renderTable = () => {
    const selectOptions = [
      { value: true, label: 'Aktív' },
      { value: false, label: 'Inaktív' }
    ];

    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'idotartam',
        text: 'Időtartam',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'aktiv',
        text: 'Állapot',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      },
      {
        dataField: 'publikus',
        text: 'Publikus',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatterPublic,
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.szolgaltatasok}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb() ?
              (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleSzolgaltatasAddClick}>Új szolgáltatás</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.renderState()}
        <Modal isOpen={this.state.modalSzolgaltatas} toggle={this.toggleSzolgaltatas} className={this.props.className} backdrop="static">
          <RFForm
            modal
            title={"Szolgáltatás " + (this.state.insert ? "felvétel" : "módosítás")}
            onSubmit={this.state.insert ? this.addSzolgaltatas : this.modifySzolgaltatas}
            footer={
              <>
                <Button color="primary">Mentés</Button>{' '}
                <Button type="button" color="secondary" onClick={this.toggleSzolgaltatas}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="Név: *"
                  name="nev"
                  maxLe
                  maxLength="50"
                  value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.nev : ''}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <RFField
                  label="Időtartam (perc): *"
                  name="idotartam"
                  numberOnlyWhole
                  value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.idotartam : ''}
                />
              </div>
              <div style={{ marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
                <RFField
                  label="Aktív"
                  type="checkbox"
                  name="aktiv"
                  id="aktiv"
                  value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.aktiv : false}
                />
              </div>
              <div style={{ marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
                <RFField
                  type="checkbox"
                  label="Publikus"
                  name="publikus"
                  id="publikus"
                  value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.publikus : false}
                />
              </div>
              <div style={{ marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
                <RFField
                  label="Választható dolgozó"
                  type="checkbox"
                  name="valaszthatodolgozo"
                  id="valaszthatodolgozo"
                  value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.valaszthatodolgozo : false}
                />
              </div>
            </div>
            <RFField
              label="Ár (Ft):"
              name="ar"
              numberOnly
              value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.ar : ''}
            />
            <RFField
              label="Leírás:"
              style={{ height: '120px' }}
              type="textarea"
              name="leiras"
              value={!this.state.insert && this.state.szolgaltatasModositObj ? this.state.szolgaltatasModositObj.leiras : ''}
            />
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalSzolgaltatasView} toggle={this.toggleSzolgaltatasView} className={this.props.className} backdrop="static">
          <ModalHeader>
            Megtekintés
          </ModalHeader>
          <ModalBody>
            <div>
              <h6>Adatok</h6>
              <b>Név: </b>{this.state.szolgaltatasModositObj.nev}<br />
              <b>Időtartam (perc): </b>{this.state.szolgaltatasModositObj.idotartam}<br />
              <b>Ár (Ft): </b>{this.state.szolgaltatasModositObj.ar}<br />
              <b>Állapot: </b>{this.state.szolgaltatasModositObj.aktiv ? 'Aktív' : 'Inaktív'}<br />
              <b>Publikus: </b>{this.state.szolgaltatasModositObj.publikus ? 'Igen' : 'Nem'}<br />
              <b>Publikus választható dolgozó: </b>{this.state.szolgaltatasModositObj.valaszthatodolgozo ? 'Igen' : 'Nem'}<br />
              <b>Leírás: </b>{this.state.szolgaltatasModositObj.leiras}<br />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleSzolgaltatasView}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalSzolgaltatasTorles} toggle={this.toggleSzolgaltatasTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a szolgáltatást?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteSzolgaltatas}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleSzolgaltatasTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default Szolgaltatas;
